<template>
<div>
    <div class="form-container ou-donation-form oua-give">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Make a gift" class="make-a-gift-section">
                    <div class="forms__label">How often?</div>
                    <DonationFrequency /> 
                    <div>
                        <div class="forms__label">Amount</div>
                        <AmountSelector amountText="Other amount" defaultCheckedAount="180"/>
                        <ErrorLabel field="amount" />
                    </div>
                   
                    <div class="forms__label">Where should your gift go?</div>
                  <FormRow class="designation" inline>
                  <FormCol field="custom.designation" width="half" :showLabel="false">
                    <FormSelect>
                      <option selected="selected" value="Wherever it is needed most">
                        Wherever it is needed most
                      </option>
                      <option value="LIAT Fellowship">LIAT Fellowship</option>
                      <option value="Federal advocacy">Federal advocacy</option>
                      <option value="Interfaith Initiatives">Interfaith Initiatives</option>
                      <option value="OU Advocacy Attorneys Conference">OU Advocacy Attorneys Conference</option>
                    </FormSelect>
                  </FormCol>
                  </FormRow>

                  <div class="in-honor-of-section">
                   <InHonorOf dedicateLabel="Dedicate this gift in honor or memory of someone" /> 
                   </div>
                </FormSection>
                <div v-if="!showDetails">
                  <p v-if="amountError" class="oua-amount-error" role="alert">Please choose an amount to continue.</p>
                  <div class="payment">
                    <button type="button" class="ou-donation-btn btn-flex" @click="revealDetails">
                      {{ giveLabel }}
                    </button>
                  </div>
                  <p class="oua-fine">OUA is a 501(c)(3). Your gift is tax-deductible.</p>
                </div>
                <div v-if="showDetails" ref="detailsEl">
                <FormSection title="Personal Info">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>

                      	<div class="consent__field">
		<FormRow>
  		<input type="checkbox" id="consent" name="consent" @click="setValue('custom.consent', $event.target.checked)" />

      <FormLabel for="consent" class="label__consent">Opt in to SMS communications</FormLabel>
		</FormRow>
    <div v-if="getValue('custom.consent')">
  		<FormLabel for="consent" class="label__consent">By providing your telephone number and checking the box, you consent to receive calls and text messages.
Msg & data rates may apply. Msg frequency may vary. Messaging may include requests for donation.
Reply “STOP” to opt-out & “HELP” for help.
        <a href="https://advocacy.ou.org/privacy-policy/" target="_blank">View Privacy Policy</a> for more info.</FormLabel>
	</div>
	</div>
                  </FormRow>                    
                    <DonorAddress />                                        
                </FormSection>                
                <FormSection title="Payment Info" last>
                    <TransactionFee v-if="form.amount"/>
            <div class="payment-info">
              <FormRow>
                <PaymentType cc_text="Payment Methods" check_text="Check" />
              </FormRow>
              <FormRow inline>
                <FormCol
                  class="doublepay"
                  field="card"
                  :showLabel="false"
                  check_text=""
                />
              </FormRow>
              <FormRow
                v-if="form.gateway === 'check'"
                class="checktext"
              >
                <div class="checktext">
                  Kindly make the contribution payable to OU Advocacy, and/or write OU Advocacy in the memo, and mail to:
                  <p style="">
                    <strong
                      >OU Advocacy, Attention: Tia Anatian<br>
        40 Rector Street<br>
        4th Floor<br>
        New York, NY 10006</strong
                    >
                  </p>
                </div>
              </FormRow>
            </div>
          </FormSection>
                <PaymentButton showAmount btnText="Give"/>
                <p class="oua-fine">OUA is a 501(c)(3). Your gift is tax-deductible.</p>
                </div>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { computed, nextTick, onMounted, ref, watch } from 'vue'
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import { queryParams } from '~/shared/query-params'

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup(props) {
    const { setValue, getValue, form, submit } = usePaymentForm()

    if (props.subCampaign) {
      setValue('applications.0.subCampaign', props.subCampaign)
    }

    onMounted(() => {
      const params = queryParams()

      if (params.utm_content) {
        if (
          !['Direct Mail', 'Telemarketing', 'Text SMS Message'].includes(
            params.utm_content
          )
        ) {
          throw new Error('Invalid subcampaign')
        }

        setValue('applications.0.subCampaign', params.utm_content)
      }
    })

    const showDetails = ref(false)
    const detailsEl = ref<HTMLElement | null>(null)
    const amountError = ref(false)

    watch(() => form.value.amount, (amount) => {
      if (Number(amount) > 0) amountError.value = false
    })

    const giveLabel = computed(() => {
      const amount = Number(form.value.amount)
      if (!amount) return 'Give'
      return `Give $${amount.toLocaleString('en-US')}${form.value.dayOfMonth ? ' monthly' : ''}`
    })

    const revealDetails = async () => {
      if (!(Number(form.value.amount) > 0)) {
        amountError.value = true
        return
      }
      showDetails.value = true
      await nextTick()
      detailsEl.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    return {
      form,
      getValue,
      setValue,
      submit,
      showDetails,
      detailsEl,
      amountError,
      giveLabel,
      revealDetails,
    }
  },
})
</script>
<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Source+Serif+4:opsz,wght@8..60,600;8..60,700;8..60,800&family=Public+Sans:wght@400;500;600;700&display=swap');

$oua-blue: #1A559F;
$oua-red: #E53B36;
$oua-mist: #E8EEF6;
$oua-ink: #1C2330;
$oua-muted: #5A6475;
$oua-line: #D5DCE6;
$oua-serif: "Source Serif 4", Georgia, "Times New Roman", serif;
$oua-sans: "Public Sans", "Helvetica Neue", Arial, sans-serif;

@mixin oua-visually-hidden-radio {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  margin: 0;
  opacity: 0;
  visibility: visible;
  pointer-events: none;
  z-index: 0;
}

.form-container.ou-donation-form.oua-give {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0px;
  background: #fff;
  color: $oua-ink;
  font-family: $oua-sans;
  line-height: 1.55;
  border-radius: 0;
  box-shadow: none;

  @media (max-width: 720px) {
  }

  .forms__label {
    font-weight: 600;
    margin-bottom: 10px;
    font-size: .95rem;
    color: $oua-ink;
  }

  .oua-fine {
    margin: 14px 0 0;
    font-size: .85rem;
    color: $oua-muted;
    text-align: center;
  }

  .oua-amount-error {
    margin: 0 0 10px;
    font-size: .9rem;
    font-weight: 600;
    color: $oua-red;
  }

  :deep(h2) {
    font-family: $oua-serif;
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 1.2;
    color: $oua-blue;
    margin: 0 0 20px;
  }

  :deep(hr) {
    border: 0;
    border-top: 1px solid $oua-line;
    margin: 8px 0 28px;
  }

  :deep(label) {
    font-family: $oua-sans;
    color: $oua-ink;
  }

  // Frequency: segmented toggle
  :deep(.styled-radio-container--ou-donation.styled-radio-container) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 0 0 20px;
    padding: 4px;
    background: $oua-mist;

    .radio-part {
      position: relative;
      width: auto;
      min-width: 0;
      max-width: none;
      padding: 0;
      margin: 0;
    }
    input[type='radio'] {
      @include oua-visually-hidden-radio;
    }
    label {
      position: relative;
      z-index: 1;
      margin: 0;
      padding: 10px;
      border: 0;
      border-radius: 0;
      background: transparent;
      color: $oua-blue;
      font-weight: 700;
      font-size: .95rem;
    }
    label:hover {
      background: rgba(255, 255, 255, .6);
    }
    input[type='radio']:checked + label {
      background: $oua-blue;
      color: #fff;
    }
    input[type='radio']:focus-visible + label {
      outline: 3px solid $oua-red;
      outline-offset: 2px;
    }
  }

  :deep(.monthly-note) {
    color: $oua-muted;
    font-size: .85rem;
  }

  // Amount grid
  :deep(.styled-radio--ou-donation.styled-radio) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    margin: 0 0 20px;

    .radio-part {
      position: relative;
      width: auto;
      min-width: 0;
      max-width: none;
      padding: 0;
      margin: 0;
    }
    input[type='radio'] {
      @include oua-visually-hidden-radio;
    }
    label {
      position: relative;
      z-index: 1;
      margin: 0;
      padding: 14px 8px;
      border: 1.5px solid $oua-line;
      border-radius: 0;
      background: #fff;
      color: $oua-blue;
      font-weight: 700;
      font-size: 1.05rem;
    }
    label:hover {
      background: #fff;
      border-color: $oua-blue;
    }
    input[type='radio']:checked + label {
      background: $oua-blue;
      border-color: $oua-blue;
      color: #fff;
    }
    input[type='radio']:focus-visible + label {
      outline: 3px solid $oua-red;
      outline-offset: 2px;
    }

    .amount_other__wrapper {
      grid-column: 1 / -1;
      display: flex;
      align-items: center;
      min-width: 0;
      max-width: none;
      margin: 0;
      padding: 0;
      border: 1.5px solid $oua-line;
      border-radius: 0;
      overflow: visible;

      &:before {
        position: static;
        height: auto;
        padding: 0 12px;
        border: 0;
        background: transparent;
        color: $oua-muted;
        font-weight: 700;
      }
      &:focus-within {
        outline: 3px solid $oua-blue;
        outline-offset: 2px;
      }
      input[type='radio'] {
        display: none;
      }
      input[type='number'] {
        flex: 1;
        width: auto;
        height: auto;
        margin: 0;
        padding: 14px 12px 14px 0;
        border: 0;
        background: transparent;
        box-shadow: none;
        font-family: inherit;
        font-size: 1rem;
        color: $oua-ink;

        &:hover,
        &:focus {
          border: 0;
          outline: none;
          box-shadow: none;
          background: transparent;
        }
      }
    }
  }

  // Text inputs + selects
  :deep(input[type='text']),
  :deep(input[type='email']),
  :deep(input[type='tel']),
  :deep(textarea),
  :deep(select) {
    height: auto;
    min-height: 48px;
    padding: 12px;
    border: 1.5px solid $oua-line;
    border-radius: 0;
    background-color: #fff;
    color: $oua-ink;
    font-family: $oua-sans;
    font-size: 1rem;
    box-shadow: none;

    &:hover {
      border-color: $oua-blue;
    }
    &:focus {
      border-color: $oua-blue;
      background-color: #fff;
      box-shadow: none;
      outline: 3px solid $oua-blue;
      outline-offset: 2px;
    }
  }
:deep(.make-a-gift-section) hr {
    display: none !important;
    padding: 0px !important;
    margin: 0px !important;
}
  :deep(.vue-tel-input) {
    border: 1.5px solid $oua-line;
    border-radius: 0;

    &:focus-within {
      border-color: $oua-blue;
      box-shadow: none;
      outline: 3px solid $oua-blue;
      outline-offset: 2px;
    }
    input {
      border: 0;
      outline: none;
    }
  }

  :deep(.designation .width-half) {
    max-width: 100%;
  }

  // Checkboxes (dedication, fee, SMS consent)
  :deep(input[type='checkbox']) {
    width: 18px;
    height: 18px;
    max-width: none;
    margin: 0 10px 0 0;
    flex-shrink: 0;
    accent-color: $oua-blue;
  }

  :deep(.inhonorof > .form-group:first-child) {
    display: flex;
    align-items: center;
    margin-bottom: 22px;

    label {
      font-size: .95rem;
    }
  }

  :deep(.honor-container) {
    margin-top: -10px;
    margin-bottom: 22px;
    padding-top: 0;
    border-top: 0;
  }

  :deep(.fee-info-container) {
    margin: 0 0 22px;
    padding: 14px 16px;
    border-radius: 0;
    background: $oua-mist;
    color: $oua-muted;
    font-size: .85rem;

    label {
      color: $oua-ink;
      font-size: .85rem;
    }
  }

  // Submit
  :deep(.payment) {
    margin: 8px 0 0;
  }
  :deep(.ou-donation-btn) {
    width: 100%;
    justify-content: center;
    padding: 18px;
    border: 0;
    border-radius: 0;
    background: $oua-red;
    color: #fff;
    font: 700 1.2rem $oua-sans;
    line-height: 1.2;
    text-transform: none;
    transition: filter .15s;

    &:hover,
    &:active,
    &:focus {
      background: $oua-red;
      color: #fff;
      filter: brightness(.92);
    }
    &:focus-visible {
      outline: 3px solid $oua-blue;
      outline-offset: 3px;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    :deep(*) {
      transition: none !important;
    }
  }
}

h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}


::v-deep .radio-part {
  @media (min-width: 720px) {
    &:nth-child(3n) {
      padding-right: 0;
    }
  }
}

.donate__content{
  max-width: 900px;
  padding: 0px 20px;
  margin: 40px auto;
  line-height: 1.4;
  p{
    margin-bottom: 1rem;
  }
}
.checktext{
    text-align: left !important;
    justify-content: flex-start;
    line-height: 1.4;
}

::v-deep  .consent__field{
  	cursor: pointer;

input[type="checkbox"] {
	margin-right: 10px;
  max-width: 15px;
  margin-bottom: 0px;
  &.consent__input{
    margin-right: 0px;
    margin-left: 10px;
  }
}


::v-deep .form-group {
  display: flex;
}
}

 .label__consent{
  line-height: normal;
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
  font-size: 14px !important;
}
.label__consent a{
  text-decoration: underline;
  color: #1A559F;
}
</style>
